import type { FC } from 'react';
import { useReducer } from 'react';
import type { IContainerChildrenProps } from 'utils';
import { v4 } from 'uuid';
import { FlowContext } from './FlowContext';
import { FlowReducer } from './FlowReducer';

const FlowProvider: FC<IContainerChildrenProps> = ({ children }) => {
  const [state, dispatch] = useReducer(FlowReducer, {
    activePanel: null,
    flowSummary: undefined,
    flowSchema: null,
    selectedComponent: null,
    flow: null,
    structureHash: v4()
  });

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <FlowContext.Provider value={{ state, dispatch }}>{children}</FlowContext.Provider>;
};

export default FlowProvider;
